//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueSlider from 'vue-slider-component';
import {mapMutations} from "vuex";
import 'vue-slider-component/theme/default.css';

export default {
  name: "Config",
  components: {VueSlider},
  mounted() {
    this.fetchAllThresholds();
    this.isExportActivated();
  },
  data: () => ({
    loading: false,
    docTypes: [],
    empty: false,
    scale: [0, 100],
    exportActivated: false,
    thresholdsHeaders: {
      'accept': 'application/xml',
    },
    exportHeaders: {
      'accept': 'text/plain',
    },
    deduplication: {
      errorCount: 0,
      processed: 0,
      total: 0,
      unindexed: 0,
    },
    pollingInterval: undefined,
    indexStarted: false,
    indexed: 0,
    notIndexed: 0,
    totalAssets: 0,
    reindex: false,
  }),
  methods: {
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
    }),
    isExportActivated() {
      this.$refs.isExportActivated.path = 'aicore/config/export';
      this.$refs.isExportActivated.get().then((result) => {
        this.exportActivated = (result === 'true');
      }).catch((error) => {
        this.displayError(error);
        this.loading = false;
      });
    },
    navigateBack() {
      this.$router.back();
    },
    toggleExport() {
      this.$refs.toggleExport.data = {
        'nuxeo.ai.continuous.export.enable': this.exportActivated,
      }
      this.$refs.toggleExport.path = 'aicore/config';
      this.$refs.toggleExport.post().catch((error) => {
        this.displayError(error);
      });
    },
    fetchAllThresholds() {
      this.loading = true;
      this.fetchModelsOutputs().then((docTypesFromCloud) => {
        this.$refs.thresholds.path = 'aicore/extension/thresholds';
        this.$refs.thresholds.get().then((result) => {
          const parser = new DOMParser();
          const dom = parser.parseFromString(result, "application/xml");
          const thresholds = dom.documentElement;
          this.docTypes = docTypesFromCloud;
          if (thresholds.hasChildNodes()) {
            Array.from(thresholds.getElementsByTagName('thresholdConfiguration')).forEach((thresholdConfiguration) => {
              this.docTypes.forEach((docType) => {
                if (docType.name === thresholdConfiguration.getAttribute('type')) {
                  docType.outputs.forEach((output) => {
                    Array.from(thresholdConfiguration.getElementsByTagName('threshold')).forEach((threshold) => {
                      if (output.name === threshold.getAttribute('xpath')) {
                        output.autocorrect = threshold.getAttribute('autocorrect');
                        output.autofill = threshold.getAttribute('autofill');
                        output.enable = true;
                      }
                    })
                  });
                }
              });
            });
          }
          this.loading = false;
        }).catch((error) => {
          this.displayError(error);
          this.loading = false;
        });
      });
    },
    startExport() {
      this.$refs.startExport.execute().then(() => {
        this.displaySuccess(this.$t('config.export.started'));
      }).catch((error) => {
        this.displayError(error);
      });
    },
    fetchModelsOutputs() {
      delete this.$refs.list_ai_models.params.queryParams;
      return this.$refs.list_ai_models
          .fetch()
          .then((results) => {
            const models = results.entries;
            if (models.length === 0) {
              this.empty = true;
              return;
            }
            const docTypeNames = [...new Set(models.map(model => model.properties['ai_model:doc_type']))];
            const docTypesFromCloud = [];
            docTypeNames.forEach((docTypeName) => {
              const filteredModels = models.filter((model) => model.properties['ai_model:doc_type'] === docTypeName);
              const allOutputs = filteredModels.map((model) => model.properties['ai_model:outputs']).flat();
              const filteredOutputsNames = [...new Set(allOutputs.map((output) => output.name))];
              const outputs = filteredOutputsNames.map((name) => {
                return {
                  name: name,
                  enable: false,
                  autofill: 100,
                  autocorrect: 100,
                }
              });
              docTypesFromCloud.push({
                name: docTypeName,
                outputs: outputs,
              });
            })
            return docTypesFromCloud;
          })
          .catch((error) => {
            this.displayError(error);
            this.loading = false;
          });
    },
    updateThresholds(docType, outputs) {
      const enabledOutputs = outputs.filter((output) => output.enable);
      if (enabledOutputs.length === 0) {
        this.removeThreshold(docType);
        return;
      }
      const config = this.getDOM(docType, enabledOutputs);
      const serializer = new XMLSerializer();
      this.$refs.thresholds.data = serializer.serializeToString(config);
      this.$refs.thresholds.path = `aicore/extension/thresholds/${docType}`;
      this.$refs.thresholds.post();
    },
    removeThreshold(docType) {
      this.$refs.thresholds.path = `aicore/extension/thresholds/${docType}`;
      this.$refs.thresholds.remove();
    },
    getDOM(docType, outputs) {
      const config = document.implementation.createDocument("", "", null);
      const thresholdConfiguration = config.createElement("thresholdConfiguration");
      config.appendChild(thresholdConfiguration);
      thresholdConfiguration.setAttribute("type", docType);
      const thresholds = config.createElement("thresholds");
      thresholdConfiguration.appendChild(thresholds);
      outputs.forEach((output) => {
        const threshold = config.createElement("threshold");
        threshold.setAttribute("xpath", output.name);
        threshold.setAttribute("autofill", output.autofill);
        threshold.setAttribute("autocorrect", output.autocorrect);
        thresholds.appendChild(threshold);
      })
      return config;
    },
    currentProgressWidth() {
      return {
        width: this.$refs["dedupLine"] ? this.$refs["dedupLine"].clientWidth * this.deduplication.processed / this.deduplication.total + 'px' : '0px'
      }
    },
    toggleTab(tab) {
      if(tab === 'tab-deduplication') {
        this.fetchDeduplicationAssets();
      }
    },
    startDeduplicationIndex(reindex){
      this.indexStarted = true;
      this.reindex = reindex;
      this.$refs.startDeduplication.params = {
        reindex: reindex,  // to reindex all or just new documents
      };
      this.$refs.startDeduplication.execute().then((resp) => {
        if (resp.value) {
          this.pollProgress(resp.value);
        }
      });

    },
    pollProgress(jobId){
      clearInterval(this.pollingInterval);
      if(jobId) {
        this.pollingInterval = setInterval(() => {
          this.$refs.deduplicationProgress.params = {
            id: jobId,
          };
          this.$refs.deduplicationProgress.execute().then((resp) => {
            if (resp.value.state === 'COMPLETED') {
              clearInterval(this.pollingInterval);
              this.pollingInterval = null;
            }

            this.deduplication = resp.value;
            this.deduplication.unindexed = resp.value.total - resp.value.processed;
          });
        }, 2000);
      }
    },
    fetchDeduplicationAssets() {
      this.$refs.deduplicationCounts.execute().then((resp) => {
        const value = resp.value;
        if(value && value.entity) {
          const counts = JSON.parse(value.entity);
          this.totalAssets = counts.totalAssetsCount;
          this.notIndexed = counts.nonIndexedAssetsCount;
          this.indexed = counts.indexedAssetsCount;
        }
      });
    }
  },
}
